<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition :title="$t('Global.Main.callDetailManagement')" icon="mdi mdi-card-account-phone-outline" />

    <v-container fluid class="fill-width mb-5">
      <v-sheet color="background" class="px-2 mb-5 neu-glow">
        <dashboard-call-filters-user
          @apply-filters="applyFilters"
          :phoneNumber="phoneNumber"
          :fromDate="dateRange[0]"
          :toDate="dateRange[1]"
        />
      </v-sheet>

      <v-sheet color="background" class="px-2 mb-5 neu-glow">
        <v-list color="background">
          <v-list-item v-if="selectedPhoneNumber">
            <span class="text-subtitle-2 mr-2">Teléfono seleccionado:</span> {{ selectedPhoneNumber }}
          </v-list-item>
          <v-list-item v-if="dateRangeText">
            <span class="text-subtitle-2 mr-2">Rango de fechas:</span> {{ dateRangeText }}
          </v-list-item>
        </v-list>
      </v-sheet>

      <!-- Mostrar tarjetas cuando hay datos -->
      
      
      <v-container fluid>
    <v-row>
      <!-- Recorrer los datos agrupados por extTrackingId -->
      <v-col v-for="(group, groupId) in groupedCallData" :key="groupId" cols="12">
        <v-card outlined class="neu-glow mb-4" elevation="2">
          <v-card-title class="text-h6 grey--text text--darken-3">
            <v-icon class="mr-2">mdi-database</v-icon>
            ID Llamada: {{ groupId }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="group"
              class="elevation-1"
              dense
              item-value="arrivedDate"
              :sort-by="['arrivedDate']"
              :sort-desc="[true]"
              :items-per-page="5" 
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Detalles de Llamada</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>

              <template v-slot:item.arrivedDate="{ item }">
                {{ formatDate(item.arrivedDate) }}
              </template>
              <template v-slot:item.answerDate="{ item }">
                {{ formatDate(item.answerDate) }}
              </template>
              <template v-slot:item.releaseDate="{ item }">
                {{ formatDate(item.releaseDate) }}
              </template>
              <template v-slot:item.holdTime="{ item }">
                {{ formatDuration(item.holdTime) }}
              </template>
              <template v-slot:item.callTime="{ item }">
                {{ formatDuration(item.callTime) }}
              </template>
              <template v-slot:item.totalHeldTime="{ item }">
                {{ formatDuration(item.totalHeldTime) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>


      <!-- Mostrar mensaje si no hay datos -->
      <v-alert v-if="noDataMessage" :value="true" color="warning" icon="mdi-alert">
        No hay datos disponibles para el número y las fechas seleccionadas.
      </v-alert>
    </v-container>
  </div>
</template>

  
  <script>
  import DashboardCallFiltersUser from './DashBoardCallFilterUser.vue';
  import ReportsApi from "@/mixins/Services/ReportsApi";
  import Utils from "@/mixins/Utils";
  
  export default {
    name: 'DashBoardCallUser',
    components: {
      DashboardCallFiltersUser,
    },
    mixins: [ReportsApi, Utils],
    data() {
      return {
        phoneNumber: '',
        selectedPhoneNumber: '',
        dateRange: [],
        data: [],
        dataToSend: {},
        loading: false,
        noDataMessage: false,
        headerMapping: {
          extTrackingId: 'Id Llamada',
          origin: 'Origen',
          destination: 'Destino',
          type: 'Tipo',
          extensionNumber: 'Extensión',
          statusType: 'Estado',
          arrivedDate: 'Fecha Entrada',
          answerDate: 'Fecha Contestación',
          releaseDate: 'Fecha Cuelgue',
          natureRelease: 'Naturaleza Cuelgue',
          holdTime: 'Tiempo Sonando',
          callTime: 'Duración Llamada',
          totalHeldTime: 'Tiempo Espera'
        },
        headers: [
        { text: "Origen", value: "origin" },
        { text: "Destino", value: "destination" },
        { text: "Tipo", value: "type" },
        { text: "Extensión", value: "extensionNumber" },
        { text: "Estado", value: "statusType" },
        { text: "Fecha Entrada", value: "arrivedDate" },
        { text: "Fecha Contestación", value: "answerDate" },
        { text: "Fecha Cuelgue", value: "releaseDate" },
        { text: "Tiempo Sonando", value: "holdTime" },
        { text: "Duración Llamada", value: "callTime" },
        { text: "Tiempo Espera", value: "totalHeldTime" },
      ],
      };
    },
    computed: {
      sortedData() {
      // Ordenar datos por fecha de entrada (descendente)
      return this.data.slice().sort((a, b) => b.arrivedDate - a.arrivedDate);
    },
      dateRangeText() {
        if (this.dateRange.length === 2) {
          return `${this.dateRange[0]} a ${this.dateRange[1]}`;
        }
        return '';
      },
      groupedCallData() {
      // Agrupar datos por extTrackingId
      return this.data.reduce((acc, item) => {
        const groupId = item.extTrackingId;
        if (!acc[groupId]) {
          acc[groupId] = [];
        }
        acc[groupId].push(item);
        return acc;
      }, {});
  }
    },
    methods: {
      recoverRequestData(filters) {
        const fromDateMillis = new Date(filters.fromDate).getTime();
        const toDateMillis = new Date(filters.toDate).getTime();
  
        this.dataToSend = {
          type: 'CALL_DETAIL_RECORD',
          from: fromDateMillis,
          to: toDateMillis,
          granularity: null,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
          remoteParty: filters.phoneNumber || null,
          companyId: this.loadCompanyId()
        };
      },
  
      formatDate(timestamp) {
        if (timestamp === null || timestamp === undefined || timestamp === 0) return '';
        if (typeof timestamp === 'number') {
          const date = new Date(timestamp);
          return date.toLocaleString('es-ES', { 
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }
        return timestamp;
      },
  
      async applyFilters(filters) {
        this.selectedPhoneNumber = filters.phoneNumber;
        this.phoneNumber = filters.phoneNumber;
  
        const fromDateFormatted = this.formatDate(filters.fromDate);
        const toDateFormatted = this.formatDate(filters.toDate);
  
        this.dateRange = [fromDateFormatted, toDateFormatted];
        this.recoverRequestData(filters);
        await this.fetchData();
      },
  
      async fetchData() {
        this.loading = true;
        this.noDataMessage = false;
        this.data = [];
  
        console.debug('[REPORTS][viewReport] Sending data:', this.dataToSend);
  
        try {
          const reportData = await this.visualizeCDRReport(this.dataToSend);
          if (Array.isArray(reportData) && reportData.length) {
            this.data = reportData;
          } else {
            console.warn('[REPORTS][viewReport] No valid data returned');
            this.noDataMessage = true;
          }
        } catch (error) {
          console.error('[REPORTS][viewReport] ERROR:', error);
          this.$emit('launch-snackbar', this.$t('Global.Error.generalError'), 'error', "4000", 'mdi-alert-octagon');
          this.noDataMessage = true;
        } finally {
          this.loading = false;
        }
      },
  
      formatDuration(milliseconds) {
        if (typeof milliseconds === 'number') {
          const seconds = Math.floor(milliseconds / 1000);
          const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
          const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
          const remainingSeconds = String(seconds % 60).padStart(2, '0');
          return `${hours}:${minutes}:${remainingSeconds}`;
        }
        return '';
      },
    },
  };
  </script>

<style scoped>
.neu-glow {
  box-shadow: 2px 2px 5px #ccc, -2px -2px 5px #fff;
}
.v-data-table {
  font-size: 0.9rem;
  line-height: 1.5;
}
.v-card-title {
  font-size: 1rem;
  display: flex;
  align-items: center;
}
</style>
  